
import { computed, defineComponent } from 'vue';
import PointInfo from '@/components/organisms/point/PointInfo.vue';
import CustomerCoupon from '@/components/organisms/coupon/CustomerCoupon.vue';
import { CustomerCoupon as TypeCustomerCoupon } from '@/repositories/couponRepository';

type Props = {
  result: {
    customerCoupons: TypeCustomerCoupon[];
    line: {
      link: string;
      displayName: string;
      pictureUrl?: string;
    };
  };
};

export default defineComponent<Props>({
  name: 'CouponActionComplete',

  components: {
    PointInfo,
    CustomerCoupon,
  },

  props: {
    success: {
      type: Boolean,
      default: false,
    },
    result: {
      type: Object,
      default: () => ({}),
    },
  },

  setup(props: Props) {
    const customerCoupons = computed(() => props.result.customerCoupons);
    const reversedCustomerCoupons = computed(() => customerCoupons.value.slice().reverse());
    const line = computed(() => props.result.line);

    return {
      customerCoupons,
      reversedCustomerCoupons,
      line,
    };
  },
});
